import React from 'react';

import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

import Modal from 'components/modal';
import Render from 'components/render';
import { COUNTRIES_WITH_NON_VERIFICATION } from 'constants/constants';
import { MIXPANEL_EVENT_NAMES } from 'constants/mixpanelEventNames';
import routes from 'constants/routes';
import { noop } from 'helpers';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { CrossIcon, Info } from 'styles/assets/icons';
import IconButton from 'UIKit/IconButton';
import DeltaButton from 'UIKit/DeltaButton';

import classes from './confirmCancelPopup.module.scss';

type ConfirmCancelPopupProps = {
  isOpen: boolean;
  close: () => void;
  selectedCountry?: null | string;
};

const ConfirmCancelPopup = ({
  isOpen,
  close,
  selectedCountry,
}: ConfirmCancelPopupProps) => {
  const history = useHistory();
  const { t } = useTranslation(['auth']);

  const isCountryRequiresNonVerification = COUNTRIES_WITH_NON_VERIFICATION.includes(
    selectedCountry as string
  );

  const onClickGetVerified = () => {
    history.push(routes.account.identityVerification);
    trackMixpanelEvent(MIXPANEL_EVENT_NAMES.ACCOUNT.IDENTITY_VERIFICATION.ALL_PAGES, {
      source: 'Signup success modal',
    });
  };

  return (
    <Modal isOpen={isOpen} className={classes.modal}>
      <div className={classes.root}>
        <div className={classes.header}>
          <h2 className={classes.heading}>{t('auth:cancelPopupHeader')}</h2>
          <IconButton
            onClick={close}
            data-testid="signupSuccessModal-confirmCloseButton"
            className={classes.crossIcon}
            onKeyDown={noop}
            icon={<CrossIcon />}
          />
        </div>
        <div className={classes.body}>
          <Render when={!isCountryRequiresNonVerification}>
            <div className={classes.row}>
              <Info className={classes.infoIcon} color="var(--negative)" />
              <span>{t('auth:exclusiveGiftOffers')} </span>
            </div>
          </Render>
          <div className={classes.row}>
            <Info className={classes.infoIcon} color="var(--negative)" />
            <span>{t('auth:tradingPriviledgesLosing')}</span>
          </div>
        </div>
        <div className={classes.buttonContainer}>
          <DeltaButton
            useBasicButton
            type="button"
            data-testid="willDoLaterButton"
            className={classes.laterButton}
            onClick={close}
          >
            {t('auth:willDoThisLater')}
          </DeltaButton>
          <DeltaButton
            useBasicButton
            type="button"
            data-testid="getVerifiedButton"
            className={classes.verifiedButton}
            onClick={onClickGetVerified}
          >
            {t('auth:getVerified')}
          </DeltaButton>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmCancelPopup;
